import React from 'react'
import { Container } from './styles'

export const Header: React.FC = () => {
  return <Container />
}
